export default {
  sui: {
    loading: {
      text: '로딩 중'
    },
    form: {
      more: '더보기',
      zhankai: '더보기',
      shouqi: '숨기기',
      query: '조회',
      reset: '초기화',
      add: '추가',
      update: '수정',
      delete: '삭제',
      required: '은(는) 필수입니다',
      export: {
        export: '내보내기',
        selectFormat: '형식 선택',
        selectedRow: '{key}개 행 선택됨',
        selectedTotal: '총 {key}개 행, 내보내기',
        line: '행'
      },
      please: {
        input: '입력해 주세요',
        select: '선택해 주세요'
      },
      time: {
        start: '시작 시간',
        end: '종료 시간',
        to: '~'
      },
      date: {
        start: '시작일',
        end: '종료일'
      },
      upload: {
        triggerText: '업로드'
      },
      expand: '펼치기',
      multiple: '다중',
      cols_hide: '헤더 설정'
    },
    table: {
      handle: '작업',
      sum: '합계',
      index: '번호',
      zanwushuju: '데이터 없음',
      queding: '확인',
      quxiao: '취소',
      lie: '열',
      yiyincang: '숨김',
      gong: '총'
    },
    tableEdit: {
      tip1: '데이터가 아직 편집 중이어서 저장할 수 없습니다!',
      tip2: '데이터를 삭제하시겠습니까?',
      baocun: '저장',
      chongzhi: '초기화',
      xinzeng: '추가',
      guanbituozhuai: '드래그 닫기',
      kaiqituozhuai: '드래그 열기',
      caozuo: '작업',
      queren: '확인',
      bianji: '편집',
      shanchu: '삭제',
      tishi: '알림'
    },
    list: {
      yi_xuan_ze: '선택됨',
      tiao: '개',
      gong: '총',
      mei_you_geng_duo: '더 이상 없음',
      zan_wu_shu_ju: '선택된 데이터가 없습니다'
    },
    bond: {
      zheng_quan_dai_ma: '채권 코드',
      zheng_quan_ming_cheng: '채권명',
      zan_wu_shu_ju: '데이터 없음',
      qu_xiao_qing_qiu: '요청이 취소되었습니다'
    },
    dialog: {
      ok: '확인',
      cancel: '취소'
    },
    page: {
      add: {
        success: '[{key}] 추가 성공'
      },
      delete: {
        title: '{key}-삭제',
        confirm: '[{key}]을(를) 삭제하시겠습니까?',
        success: '[{key}] 삭제 성공'
      },
      update: {
        success: '[{key}] 수정 성공',
        noChange: '데이터가 변경되지 않아 저장하지 않았습니다'
      }
    },
    tablePage: {
      export: {
        tip1: '올바른 행 번호를 입력해 주세요',
        tip2: '내보내기 형식',
        tip3: '선택',
        tip4: '다음으로 내보내기',
        tip5: '내보내기 파일 형식을 선택해 주세요',
        lie: '열',
        hang: '행',
        shi: '예',
        fou: '아니오',
        daochu: '내보내기',
        wancheng: '확인',
        quxiao: '취소',
        gong: '총',
        type1: '순차 내보내기',
        type2: '수동 선택 내보내기',
        daochu_geshi: '내보내기 파일 형식'
      }
    },
    editlist: {
      caozuo: '작업',
      shanchu: '삭제',
      xinzeng: '추가'
    },
    upload: {
      tip1: '삭제 키를 눌러 삭제'
    },
    uploadPro: {
      tip1: 'Websocket 연결이 끊어졌습니다. 재연결 시도 중',
      tip2: '연결이 끊어졌습니다'
    },
    select: {
      jiazaizhong: '로딩 중',
      wupipeishuju: '일치하는 데이터 없음',
      wushuju: '데이터 없음',
      quanxuan: '전체 선택',
      fanxuan: '반전'
    },
    transfer: {
      tip1: '검색',
      liebiao1: '목록 1',
      liebiao2: '목록 2'
    },
    treeGrid: {
      caozuolan: '작업'
    },
    empty: {
      zanwuneirong: '데이터 없음'
    },
    valid: {
      char: '문자',
      len1: '{p1}을(를) 입력해 주세요',
      len2: '{p1}에서 {p2} 사이를 입력해 주세요',
      num: '숫자',
      pInt: '양의 정수',
      npInt: '음이 아닌 정수',
      nInt: '음의 정수',
      nNInt: '음이 아닌 정수',
      int: '정수',
      pFNum: '양의 실수',
      nFNum: '음의 실수',
      num_: '숫자(-,_)',
      en: '영문자',
      en_: '영문자(-,_)',
      ch: '한자',
      ch_: '한자(-,_)',
      nch: '한자가 아닌 문자',
      numEn: '숫자 또는 영문자',
      numEn_: '숫자 또는 영문자(-,_)',
      chEnNum: '숫자, 영문자 또는 한자',
      chEnNum_: '숫자, 영문자 또는 한자(-,_)',
      phone: '전화번호',
      email: '이메일',
      idcard: '신분증 번호',
      url: 'URL',
      reg: '올바른 형식으로 입력해 주세요',
      version: '버전 태그',
      uri: 'URI',
      datasource: '데이터 소스',
      intRegion: '정수 {p1}에서 {p2} 사이',
      floatRegion: '실수 {p1}에서 {p2} 사이'
    },
    timerange: {
      jue_dui_shi_jian_fan_wei: '절대 시간 범위',
      xiang_dui_shi_jian_fan_wei: '상대 시간 범위',
      kai_shi_shi_jian: '시작 시간',
      jie_su_shi_jian: '종료 시간',
      zui_jin_wu_fen_zhong: '최근 5분',
      zui_jin_shi_wu_fen_zhong: '최근 15분',
      zui_jin_san_shi_fen_zhong: '최근 30분',
      zui_jin_yi_xiao_shi: '최근 1시간',
      zui_jin_san_xiao_shi: '최근 3시간',
      zui_jin_liu_xiao_shi: '최근 6시간',
      zui_jin_shi_er_xiao_shi: '최근 12시간',
      zui_jin_er_shi_si_xiao_shi: '최근 24시간',
      zui_jin_liang_tian: '최근 2일',
      zui_jin_qi_tian: '최근 7일',
      zui_jin_san_shi_tian: '최근 30일'
    },
    bookmark: {
      biao_ti: '북마크',
      xin_zeng_shu_qian: '북마크 추가',
      ming_cheng: '이름',
      fu_gai: '덮어쓰기',
      chong_ming_ming: '이름 변경',
      shan_chu: '삭제',
      ming_cheng_xiu_gai_cheng_gong: '이름이 성공적으로 수정되었습니다',
      xin_zeng: '추가',
      shan_chu_ti_shi: '[{name}]을(를) 삭제하시겠습니까?',
      shan_chu_cheng_gong: '성공적으로 삭제되었습니다',
      xin_zeng_cheng_gong: '북마크가 성공적으로 추가되었습니다!',
      tian_jia_ji_lu: '기록에 추가',
      gong: '총',
      tiao: '개',
      bao_cun: '저장',
      qing_wan_cheng_zheng_zai_tian_jia_xiang: '기록이 추가 중인지 확인해 주세요'
    },
    messageBox: {
      qing_shuru_yanzhengma: '인증 코드를 입력해 주세요',
      yanzhengma_bu_zhengque: '잘못된 인증 코드'
    },
    jsonEditor: {
      fuzhi: '복사'
    },
    cron: {
      second: '초',
      minute: '분',
      hour: '시',
      day: '일',
      month: '월',
      week: '주',
      year: '년',
      cron_biaodashi_ziduan: 'Cron 표현식 필드',
      hanhua_fanyi: '한국어 번역',
      chongzhi: '초기화',
      single: '매 ',
      mei_nian: '매년',
      mei_yue: '매월',
      mei_ri: '매일',
      mei_tian: '매일',
      mei_shi: '매시',
      xiaoshi: '시간',
      mei_fenzhong: '매분',
      mei_miao: '매초',
      mei_zhou: '매주',
      cong: '부터',
      yue_qi_mei_ge: '매월',
      ri_qi_mei_ge: '매일',
      shi_qi_mei_ge: '매시',
      fenzhong_qi_mei_ge: '매분',
      miao_qi_mei_ge: '매초',
      zuihou_yitian: '마지막 날',
      zhi: '까지',
      cong_zhou: '주부터',
      zhi_zhou: '주까지',
      qi_meige: '매',
      tian_zhixingyici: '하루에 한 번',
      xiaoshi_zhixingyici: '한 시간에 한 번',
      yue_zhixingyici: '한 달에 한 번',
      zhixingyici: '한 번 실행',
      ben_yue_di: '이번 달',
      ben_yue: '이번 달',
      xinqi: '주',
      benyue_zuihou_yige_xingqi: '이번 달 마지막 주',
      buzhiding: '지정하지 않음',
      zhouqi_cong: '주기 시작',
      xunhuan_cong: '반복 시작',
      tip1: '매일',
      tip2: '가장 가까운 근무일',
      tip3: '시작, 매시간',
      tip4: '시작, 매월',
      tip5: '요일',
      benyue_zuihou_yitian: '이번 달 마지막 날',
      zhiding: '지정',
      kaishi: '시작',
      kaishi_mei: '매 시작',
      benyue: '이번 달',
      mei: '매',
      zhixing: '실행',
      zhouqi: '주기',
      di: '번',
      mess1: '날짜와 요일을 동시에 "지정하지 않음"으로 설정할 수 없습니다',
      mess2: '날짜와 요일 중 하나는 "지정하지 않음"으로 설정해야 합니다',
      zhouri: '일요일',
      zhouyi: '월요일',
      zhouer: '화요일',
      zhousan: '수요일',
      zhousi: '목요일',
      zhouwu: '금요일',
      zhouliu: '토요일'
    },
    treeGraph: {
      fangda: '확대',
      suoxiao: '축소',
      shuaxin: '새로고침'
    }
  }
} 


// WEBPACK FOOTER //
// ./src/components/SimbartUI/lang/ko-KR.js